var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-switch',{staticClass:"mt-0",attrs:{"label":_vm.debugValue ? 'enabled' : 'disabled',"hide-details":""},model:{value:(_vm.debugValue),callback:function ($$v) {_vm.debugValue=$$v},expression:"debugValue"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }